export const USER_RECEIVE = 'USER_RECEIVE';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_COMPLETE = 'LOGOUT_COMPLETE';
export const LOGOUT_FAILED = 'LOGOUT_FAILED';

export const USER_ACCEPT_TERMS_REQUEST = 'ACCEPT_TERMS_REQUEST';
export const USER_ACCEPT_TERMS_REQUEST_COMPLETE = 'ACCEPT_TERMS_COMPLETE';
export const USER_ACCEPT_TERMS_REQUEST_FAILED = 'ACCEPT_TERMS_FAILED';

const userReceive = me => ({
  type: USER_RECEIVE,
  me,
});

export const logoutRequest = message => ({
  type: LOGOUT_REQUEST,
  message,
});

export const logoutComplete = () => ({
  type: LOGOUT_COMPLETE,
});

export const logoutFailed = error => ({
  type: LOGOUT_FAILED,
  error,
});

const acceptTermsRequest = policyTypes => ({
  type: USER_ACCEPT_TERMS_REQUEST,
  policyTypes,
});

const acceptTermsComplete = () => ({
  type: USER_ACCEPT_TERMS_REQUEST_COMPLETE,
});

const acceptTermsFailed = () => ({
  type: USER_ACCEPT_TERMS_REQUEST_FAILED,
});

export default {
  userReceive,
  logoutRequest,
  acceptTermsRequest,
  acceptTermsComplete,
  acceptTermsFailed,
};
